import { render, staticRenderFns } from "./selectIndentity.vue?vue&type=template&id=5b6ffd36&"
import script from "./selectIndentity.vue?vue&type=script&lang=js&"
export * from "./selectIndentity.vue?vue&type=script&lang=js&"
import style0 from "./selectIndentity.vue?vue&type=style&index=0&lang=css&"
import style1 from "./selectIndentity.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports